import React from 'react'
import LinkBox from './LinkBox'
import styled from 'styled-components'
import { theme } from "Theme"
import Config from "Data"
const EventCard = styled((props) => <LinkBox {...props} />)`
`

const OptionEventCardLink = (props) => {
    return (<EventCard {...props}>{props.children}</EventCard>)
}

export default OptionEventCardLink;